
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beast",
      function () {
        return require("private-next-pages/beast/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beast"])
      });
    }
  